import { Card } from '@acceso/design-system';
import clsx from 'clsx';

import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';
import { useUnderMinDesktopWidth } from '@/hooks/useUnderMinDesktopWidth';

import { ClipDetailCardBody } from './ClipDetailCardBody';
import { ClipDetailCardHeader } from './ClipDetailCardHeader';
import { ClipDetailNavigation } from './ClipDetailNavigation';

export function ClipDetailCard() {
  const { underMinDesktopWith } = useUnderMinDesktopWidth();

  const { visibleBroadcastProgramCards, pinnedId } = useBroadcastScheduleProgram();

  const mainCardsVisible = pinnedId && visibleBroadcastProgramCards.segmentDetail;

  return (
    <Card
      classes={{
        rootSection: clsx(
          '!min-w-full w-full flex-auto order-3 lg:order-2 overflow-auto max-h-[600px] lg:max-h-full',
          {
            '!max-w-[540px] !min-w-0': mainCardsVisible && underMinDesktopWith,
            'max-w-[30%]': mainCardsVisible && !underMinDesktopWith,
          }
        ),
        container: 'py-size-4',
        bodyContainer: '!pt-0',
      }}
      id="clip-detail-card"
    >
      <div className="flex flex-col gap-2">
        <ClipDetailCardHeader />
        <ClipDetailCardBody />
        <ClipDetailNavigation />
      </div>
    </Card>
  );
}
